import type { CatalogTransport } from './warehouse-catalog-client';
export type UatView = { kind: 'actual' | 'none' } | { kind: 'department'; departmentId: string };
export function uatHost(hostname: string) {
  return ['dev-finance.dispel.work', 'localhost', '127.0.0.1'].includes(hostname);
}
export function parseUat(value: unknown): { environment: 'sb1'; view: UatView } {
  if (!value || typeof value !== 'object') throw new Error('Invalid UAT context');
  const context = value as { environment?: unknown; view?: { kind?: unknown; departmentId?: unknown } };
  const view = context.view;
  if (context.environment !== 'sb1' || !view || !['actual', 'none', 'department'].includes(String(view.kind))) throw new Error('Invalid UAT context');
  if (view.kind === 'department') {
    if (typeof view.departmentId !== 'string' || !/^[1-9][0-9]{0,14}$/.test(view.departmentId)) throw new Error('Invalid department');
    return { environment: 'sb1', view: { kind: 'department', departmentId: view.departmentId } };
  }
  if (view.departmentId !== undefined) throw new Error('Unexpected department');
  return { environment: 'sb1', view: { kind: view.kind as 'actual' | 'none' } };
}
export function uatTransport(transport: CatalogTransport, view: UatView): CatalogTransport {
  return async (path, init) => {
    const params = new URLSearchParams({ viewAs: view.kind });
    if (view.kind === 'department') params.set('viewDepartment', view.departmentId);
    const response = await transport(`${path}${path.includes('?') ? '&' : '?'}${params}`, init);
    // A missing/old API must not display figures as verified SB1 observations.
    if (response.ok && response.headers.get('X-Finance-Environment') !== 'sb1') throw new Error('SB1 not established');
    return response;
  };
}
